import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { HeaderService } from '../../tools/header.service';
import { IxellAPIService, SearchResponseMarket, SearchResponseVariants, SearchResponseFormula, Results, Variants } from '../../tools/api.service';
import { Model } from '../../entities/model';
import { Router } from '@angular/router';
import { SearchResultMixitCloud } from 'src/app/entities/searchResultMixitCloud';
import { SearchCritMixitCloud } from 'src/app/entities/searchCritMixitCloud';
import { StorageService } from 'src/app/tools/storage.service';
import { Utils } from '../../tools/utils';

@Component({
    selector: 'globalMixitCloud',
    templateUrl: './globalMixitCloud.component.html',
    styleUrls: ['./globalMixitCloud.component.scss']
})

export class GlobalMixitCloudComponent implements OnInit, OnDestroy {

    colorCode: string = "";
    manufacturer: string = "";
    country: string;
    langue: string;
    countries: any[] = Utils.countries();

    teintesMeres: SearchResponseMarket;
    teintesMeresResults: Results[];
    teinteMeresSelected: SearchResponseMarket;
    variantes: SearchResponseVariants;
    variante: Variants;
    infoVariantes: string;
    formule: SearchResponseFormula;
    seeFiltreColorWebTech: boolean = true;
    applicationAccessoire: boolean = false;

    searchResult: SearchResultMixitCloud;

    teinteAccessoire: Results;
    teintesMeresAccessoire: Results[];
    infoAccessoire: string;
    selectedPart: string;
    listApplicationAccessoire: string[];


    seeMultiTon: boolean;
    teinteMultiTon: Results;
    teintesMeresMultiTon: Results[];
    infoMultiTon: string;

    model: Model;
    title: string;
    logo: string;

    searchCrit: SearchCritMixitCloud;

    private canBackSub: any;
    private backSub: any;

    constructor(private headerService: HeaderService, private apiService: IxellAPIService, private router: Router, private storage: StorageService) { }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ngOnInit
     */
    ngOnInit() {


        if (this.storage.get("colorCode") != null) {
            this.colorCode = this.storage.get("colorCode");
            this.storage.remove("colorCode");
        }

        //if (this.storage.get("manufacturer") != null) {
        //    this.manufacturer = this.storage.get("manufacturer");
        //    if (this.manufacturer.toLowerCase() == "dacia" || this.manufacturer.toLowerCase() == "alpine")
        //        this.manufacturer = "";
        //    else
        //        this.storage.remove("manufacturer");
        //}

        ///*----------------------------------------------------------------------------------------------------*/console.log("ngOnInit globalMixitClouod");
        ///*----------------------------------------------------------------------------------------------------*/console.log("selectedPart", this.selectedPart);
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.teinteAccessoire);
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeresAccessoire);
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.storage.get(\"country\")", this.storage.get("country"));
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.countries", this.countries);

        this.country = this.storage.get("country") ? this.countries.find(c => c.name.toLowerCase() == this.storage.get("country").toLowerCase() || c.vo.toLowerCase() == this.storage.get("country").toLowerCase()).name : "FR";
        this.langue = this.storage.get("actualLanguage");

        this.backSub = this.headerService.currentBack.subscribe(back => {
            ///*----------------------------------------------------------------------------------------------------*/console.log("function Equinox back");

            ///*----------------------------------------------------------------------------------------------------*/console.log(back);
            ///*----------------------------------------------------------------------------------------------------*/console.log(this.formule);
            ///*----------------------------------------------------------------------------------------------------*/console.log(this.variantes);
            ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeres);
            ///*----------------------------------------------------------------------------------------------------*/console.log(this.teinteAccessoire);
            ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeresAccessoire);

            if (back) {
                //if (this.searchCrit != null && this.searchCrit.manufacturer != null)
                //    if (this.searchCrit.manufacturer != null && this.searchCrit.manufacturer != "" && this.searchCrit.manufacturer.toLowerCase() != "dacia" && this.searchCrit.manufacturer.toLowerCase() != "alpine")
                //        this.storage.set("manufacturer", this.searchCrit.manufacturer);

                if (this.formule != null) {
                    this.formule = null;
                    if (this.variantes.variants.length == 1) {
                        this.variantes = null;
                        if (this.teinteAccessoire != null) {
                            this.seeFiltreColorWebTech = false;
                            this.applicationAccessoire = true;
                            this.seeMultiTon = false;
                        } else if (this.teinteMultiTon != null) {
                            this.seeFiltreColorWebTech = false;
                            this.applicationAccessoire = false;
                            this.seeMultiTon = true;
                        } else {
                            this.seeFiltreColorWebTech = true;
                            this.applicationAccessoire = false;
                            this.seeMultiTon = false;
                        }
                    }
                } else {
                    if (this.variantes != null) {
                        this.variantes = null;
                        if (this.teinteAccessoire != null) {
                            this.seeFiltreColorWebTech = false;
                            this.applicationAccessoire = true;
                            this.seeMultiTon = false;
                        } else if (this.teinteMultiTon != null) {
                            this.seeFiltreColorWebTech = false;
                            this.applicationAccessoire = false;
                            this.seeMultiTon = true;
                        } else {
                            this.seeFiltreColorWebTech = true;
                            this.applicationAccessoire = false;
                            this.seeMultiTon = false;
                        }
                    } else {
                        if (this.teinteAccessoire != null) {
                            this.seeFiltreColorWebTech = true;
                            this.applicationAccessoire = false;
                            this.seeMultiTon = false;
                            this.teinteAccessoire = null;
                            this.teintesMeresAccessoire = null;
                        } else if (this.teinteMultiTon != null) {
                            this.seeFiltreColorWebTech = true;
                            this.applicationAccessoire = false;
                            this.seeMultiTon = false;
                            this.teinteMultiTon = null;
                            this.teintesMeresMultiTon = null;
                        } else {
                            if (this.teintesMeres != null && this.teintesMeresResults != null) {
                                this.seeFiltreColorWebTech = true;
                                this.applicationAccessoire = false;
                                this.seeMultiTon = false;
                                this.teintesMeres = null;
                                this.teintesMeresResults = null;
                                if (this.storage.get("previous") == "colorbook") {
                                    this.router.navigate(["/colorbook"]);
                                    this.storage.remove("previous");
                                    this.headerService.changeLogo("");
                                }
                            } else {
                                this.headerService.changeTitle("IxellWebLab");
                                this.headerService.changeCanBack(false);
                                this.router.navigateByUrl("/colorwebtech");
                                this.headerService.changeLogo(null);
                            }
                        }
                    }
                }
                this.headerService.changeBack(false);
            }
        });


        this.headerService.changeCanBack(true);
        this.headerService.changeTitle("Equinox");

        this.searchCrit = {
            colorCode: this.colorCode,
            colorGroup: "",
            manufacturer: this.manufacturer,
            model: "",
            year: "",
            listConstructeur: [],
            listModele: [],
            listAnnee: [],
            listGroupeCouleur: [],
            listApplication: [],
            listGroupeCouleurInitial: [],
            listGroupeCouleurConstructeur: [],
            listGroupeCouleurModele: [],
            listGroupeCouleurAnnee: [],
            selectedConstructeur: false,
            selectedModele: false,
            selectedAnnee: false,
            selectedGroupeCouleur: false,
            selectedApplication: false,
            lengthTotalSearch: 0,
            positionInSearch: 0,
            lengthTotalSearchAccessoire: 0,
            positionInSearchAccessoire: 0,
            lengthTotalSearchMultiTon: 0,
            positionInSearchMultiTon: 0
        };

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * search
     * @param event
     */
    search(event: any) {
        this.teintesMeres = event.teintesMeres;
        this.teintesMeresResults = event.teintesMeres.results;
        this.searchCrit = event.crit;
    }

    selectAccessoire(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function selectAccessoire");
        ///*----------------------------------------------------------------------------------------------------*/console.log(event);
        this.seeFiltreColorWebTech = false;
        this.applicationAccessoire = true;
        this.seeMultiTon = false;
        this.teinteAccessoire = event;
        this.infoAccessoire = event.codesCar[0] + " (" + event.colorDescription + ")";
        this.selectedPart = "tous";
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.selectedPart", this.selectedPart);
    }

    selectTeintesAccessoire(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function selectTeintesAccessoire");
        ///*----------------------------------------------------------------------------------------------------*/console.log(event);
        this.teintesMeresAccessoire = event;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * selectVariantes
     * @param event
     */
    selectVariantes(event: any) {

        ///*----------------------------------------------------------------------------------------------------*/console.log("function selectVariantes");
        ///*----------------------------------------------------------------------------------------------------*/console.log("teinte accessoire");
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.teinteAccessoire);
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeresAccessoire);
        ///*----------------------------------------------------------------------------------------------------*/console.log("teinte");
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeres);
        ///*----------------------------------------------------------------------------------------------------*/console.log("event", event);
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeresResults);

        let teinteInfoVariante = event.teintesMeres.results[0];
        ///*----------------------------------------------------------------------------------------------------*/console.log("teinteInfoVariante", teinteInfoVariante);

        this.teinteMeresSelected = event.teintesMeres;
        this.infoVariantes = teinteInfoVariante.ixellCode + " (" + teinteInfoVariante.colorDescription + ")" + " - " + teinteInfoVariante.ownerName + " (" + teinteInfoVariante.colorUsedInYearsDescription + ") - " + teinteInfoVariante.originalTypeOfColor
        this.variantes = event.variantes;
        this.variantes.akzoCode = teinteInfoVariante.ixellCode;
        this.searchCrit = event.crit;

        this.seeFiltreColorWebTech = false;
        this.applicationAccessoire = false;
        this.seeMultiTon = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * selectFormule
     * @param event
     */
    selectFormule(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function selectFormule");
        ///*----------------------------------------------------------------------------------------------------*/console.log("event", event);
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.variantes", this.variantes);

        this.formule = event.formule;
        this.variante = event.variante;
        this.formule.colorInfo.name = this.formule.colorInfo.name.replace(this.formule.colorInfo.akzoCode, this.variantes.akzoCode);
        this.formule.colorInfo.akzoCode = this.variantes.akzoCode;
        this.searchCrit = event.crit;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * selectLigneFormule
     * @param event
     */
    selectLigneFormule(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function selectFormule");
        ///*----------------------------------------------------------------------------------------------------*/console.log("event", event);
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.variantes", this.variantes);

        this.formule = event.formule;
        this.formule.colorInfo.name = this.formule.colorInfo.name.replace(this.formule.colorInfo.akzoCode, this.variantes.akzoCode);
        this.formule.colorInfo.akzoCode = this.variantes.akzoCode;
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * outputSelectPart
     * @param event
     */
    outputSelectPart(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function outputSelectPart");
        ///*----------------------------------------------------------------------------------------------------*/console.log("event", event);
        this.selectedPart = event;
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.selectedPart", this.selectedPart);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * outputListApplicationAccessoire
     * @param event
     */
    outputListApplicationAccessoire(event: any) {
        this.listApplicationAccessoire = event;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * outputListApplicationAccessoire
     * @param event
     */
    outputResultTeintesMeresMultiTon(event: any) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function outputResultTeintesMeresMultiTon");
        /*----------------------------------------------------------------------------------------------------*/console.log("event", event);

        this.seeFiltreColorWebTech = false;
        this.applicationAccessoire = false;
        this.seeMultiTon = true;
        this.teinteMultiTon = event;
        //this.infoMultiTon = event.combinationOf.join(" ");
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * outputListApplicationAccessoire
     * @param event
     */
    outputListResultTeintesMeresMultiTon(event: any) {
        this.teintesMeresMultiTon = event;
        this.infoMultiTon = "";
        for (var i = 0; i < this.teintesMeresMultiTon.length; i++) {
            this.infoMultiTon += event[i].codesCar[0] + " ";
        }

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * outputLangue
     */
    outputLangue() {
        let language = this.storage.get("actualLanguage");
        if (language == "" || language == null)
            language = "fr";
        this.langue = language;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ngOnDestroy
     */
    ngOnDestroy(): void {
        if (this.canBackSub != null) this.canBackSub.unsubscribe();
        if (this.backSub != null) this.backSub.unsubscribe();
    }

}
